import { LabMDM } from "./lab";

//this model is used to define the type of the machine used in the lab
export class MachineType {

    _id: string;

    name: string;

    /** stores if the boolean value is active or not */
    active: boolean;

    /** The MachineType where the concerned lab is located. */
    lab: LabMDM;
    
    description:string;

    /** If this machine type can do Liquid Handling */
    liquidHandling: boolean;

    /** If this machine type can do Measurements */
    measurements: boolean;

    /** If this machine type can do Scanning */
    scanner: boolean;
}